export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9537.8736e649.jpg";